import { render } from "./FormBuilder.vue?vue&type=template&id=c90f98ce&scoped=true"
import script from "./FormBuilder.vue?vue&type=script&lang=js"
export * from "./FormBuilder.vue?vue&type=script&lang=js"

import "./FormBuilder.vue?vue&type=style&index=0&id=c90f98ce&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c90f98ce"]])

export default __exports__